
define('app/dashboard/account/views/accountDispNameView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel'
], function($, _, Backbone, UserModel){
	var Event = _.extend({}, Backbone.Events);

	var ChangeDispNameFooterView = Backbone.View.extend({
		events: {
			'click #changeDispNameFormSubmit': 'submitChangeForm'
		},
		
		initialize: function(options) {
			this.showForm();
			
			this.listenTo(Event, 'default', this.showForm);
			this.listenTo(Event, 'saving', this.showNonForm);
			this.listenTo(Event, 'error', this.showForm);
			this.listenTo(Event, 'success', this.showForm);
		},
		
		submitChangeForm: function () {
			Event.trigger("save");
		},
		
		showForm: function () {
			$(this.el).show();
		},
		
		showNonForm: function () {
			$(this.el).hide();
		},
	});

	var ChangeDispNameContentView = Backbone.View.extend({	
		initialize: function(options) {
			this.hideAll();
			
			this.listenTo(Event, 'save', this.submitChange);
			this.listenTo(Event, 'default', this.form);
			this.listenTo(Event, 'saving', this.processing);
			this.listenTo(Event, 'error', this.form);
			this.listenTo(Event, 'success', this.success);
			
			//Error handling
			this.listenTo(Event, 'error:displayname', this.errorDispName);
		},
		
		submitChange: function () {
			Event.trigger("saving");
			
			var err = false;
			var errCode = "";
			
			//Make sure the display name isn't empty
			if(!this.$("#changeDispNameInput").val()){
				err = true;
				errCode = "NULL";
			}
			
			if(!err){
				this.model.save({
						displayName: this.$("#changeDispNameInput").val()
					}, {
						wait: true,
						success : function(model, response){
							Event.trigger("savingSuccess", model, response);
						}, 
						error : function(model, error){
							Event.trigger("savingError", model, error);
					}});	
			} else {
				Event.trigger("error");
				Event.trigger("error:displayname", errCode);
			}
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			//Hide error messages
			this.$("#changeDispNameInput").removeClass("error");
			this.$("#changeDispNameErrMsg").hide();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
		},
		
		processing: function () {
			this.hideAll();
		},
		
		form: function () {
			this.hideAll();
			$(this.el).show();
		},
		
		errorDispName : function (errorCode) {
			this.$("#changeDispNameInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#changeDispNameErrMsg").html("Display name is empty");
					this.$("#changeDispNameErrMsg").show();
					break;
				case "LENGTH": 
					this.$("#changeDispNameErrMsg").html("Display name must be between 5 and 20 characters long");
					this.$("#changeDispNameErrMsg").show();
					break;
				case "ALPHANUMSPACE": 
					this.$("#changeDispNameErrMsg").html("Display name may only contain alpha numeric characters");
					this.$("#changeDispNameErrMsg").show();
					break;
				default : 
					this.$("#changeDispNameErrMsg").html("Display name is invalid");
			}
		}
	});

	var ChangeDispNameMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			this.listenTo(Event, 'default', this.hideAll);
			this.listenTo(Event, 'saving', this.processing);
			this.listenTo(Event, 'error', this.error);
			this.listenTo(Event, 'success', this.success);
		},
		
		hideAll: function() {
			$(this.el).hide();
			this.$("#changeDispNameBodyMessageError").hide();
			this.$("#changeDispNameBodyMessageProcessing").hide();
			this.$("#changeDispNameBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#changeDispNameBodyMessageError").show();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#changeDispNameBodyMessageSuccess").show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#changeDispNameBodyMessageProcessing").show();
		},
	});
	
	var ChangeDispNameView = Backbone.View.extend({
		el: $("#changeDispNameContent"),
		
		initialize: function(options) {
			this.message = new ChangeDispNameMessageView({el: this.$("#changeDispNameBodyMessage"), model: this.model});
			this.content = new ChangeDispNameContentView({el: this.$("#changeDispNameBodyContent"), model: this.model});
			this.footer = new ChangeDispNameFooterView({el: this.$("#changeDispNameSubmitFooter"), model: this.model});
			
			_.bindAll(this, 'formSubmit');
			
			this.listenTo(Event, 'savingSuccess', this.submitted);
			this.listenTo(Event, 'savingError', this.submitError);
			this.listenTo(Event, 'success', this.success);
			
			var dispNameOpenBtn = $('#changeDispNameOpen');
			
			dispNameOpenBtn.on('click', {el: this.$("#changeDispNameBodyContent")}, function (event) {
				event.data.el.collapse('toggle');
			});
			
			this.$("#changeDispNameBodyContent").on('hide', {el: dispNameOpenBtn}, function (event) {
				event.data.el.show();
			});
			
			this.$("#changeDispNameBodyContent").on('show', {el: dispNameOpenBtn}, function (event) {
				event.data.el.hide();
			});
			
			this.$("#changeDispNameBodyContent").submit(this.formSubmit);
		},
		
		render: function () {
			Event.trigger("default");
			return this;
		},
		
		submitError: function(model, error) {
			if (error.status == 400) {
				//Input errors
				Event.trigger("error");
				
				var errObj = JSON.parse(error.responseText);
				
				if(errObj.code){
					for(var i=0; i< errObj.code.length; i++){
						if(errObj.code[i].indexOf("_") > 0){
							//Trigger a specific event for the field with the code attached as a param
							var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
							var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
							Event.trigger("error:" + field.toLowerCase(), errCode);
						}
					}
				}
			} else {
				Event.trigger("error");
			}
		},
		
		submitted: function () {
			Event.trigger("success");
		},
		
		success: function () {
			this.$("#changeDispNameBodyContent").collapse('hide');
		},
		
		formSubmit: function(e) {
			e.preventDefault();
			return false;
		},
	});
	
	return ChangeDispNameView;  
});